import { css } from 'styled-components'

export const Notifications = css`
  z-index: 999;
`
